export function useDepartments() {
    onMounted(async () => {
        EventBus.$on(CHANGE_LOCALE_EVENT, load)
        await load()
    })

    onUnmounted(() => {
        EventBus.$off(CHANGE_LOCALE_EVENT, load)
    })

    const {locale} = useI18n()
    const load = async () => {
        if (locale.value !== runtimeStore.departmentsLocale) await runtimeStore.loadDepartments()
    }
    const getDepartmentById = (id: number) => runtimeStore.departments.find(department => department.id === id)
    const getDepartmentNameById = (id: number) => getDepartmentById(id)?.name || id

    const departments = computed(() => runtimeStore.departments)

    return {departments, getDepartmentNameById}
}
